define('views/modules/setting/business/payment/payment-update-method-notice',[
    // Libs
    'backbone', 'mustache',
    // views
    'views/parts/info-section',
    // templates
    'text!templates/modules/setting/business/payment/payment-update-method-notice.html'
], function(
    // Libs
    Backbone, Mustache,
    // views
    VInfoSection,
    // templates
    TPaymentUpdateMethodNotice
) {

    var VPaymentUpdateMethodNotice = Backbone.Epoxy.View.extend({
        template: TPaymentUpdateMethodNotice,

        initialize: function(opt) {
            this.options = opt = opt || {};

            this.view = {
                info: new VInfoSection({
                    hideTitleSection: true,
                })
            };
        },

        render: function(hiddenDelay) {
            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext());

            this.assign(view.info, this.$el) // must be first
                .generateZones();

            view.info.setContent(html);

            this.applyBindings();

            return this;
        },

        toggleDisplay: function(isCreditCardPayment) {
            this.$el.toggleClass('hidden', !isCreditCardPayment);
        },
    });

    return VPaymentUpdateMethodNotice;
});

